import {useProfile} from "~/lib/profile-context";

export const useProfileFullName = (): string | null => {
    const { profile } = useProfile();

    return !profile ? null : `${profile.firstName} ${profile.lastName}`;
}